import { render, staticRenderFns } from "./ChildrenProfile.vue?vue&type=template&id=63dfbd78&scoped=true"
import script from "./ChildrenProfile.vue?vue&type=script&lang=js"
export * from "./ChildrenProfile.vue?vue&type=script&lang=js"
import style0 from "./ChildrenProfile.vue?vue&type=style&index=0&id=63dfbd78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dfbd78",
  null
  
)

export default component.exports